// extracted by mini-css-extract-plugin
export default {"app":"App_app__GfPJH","appContainer":"App_appContainer__vB0L0","grid":"App_grid__OzpeH"};